import React from "react";
import Trail from "./Trail";

export function TrailThread(
  state,
  kitDownloadStatus,
  trail,
  selectIntTypeStatus,
  uploadStartStatus,
  uploadFinishStatus,
  ipFormStatus,
  publicKeyStatus,
  runTestStatus,
  scheduleMigrationStatus,
  docApproval,
  ipPermitApproval,
  testApproval,
  migrationApproval,
  requestManager
) {
  return (
    <Trail
      kit={state.kit}
      kitDownloadStatus={kitDownloadStatus}
      selectType={state.selectType}
      selectIntTypeStatus={selectIntTypeStatus}
      uploadStartStatus={uploadStartStatus}
      uploadFinishStatus={uploadFinishStatus}
      ipFormStatus={ipFormStatus}
      publicKeyStatus={publicKeyStatus}
      runTestStatus={runTestStatus}
      scheduleMigrationStatus={scheduleMigrationStatus}
      docApproval={docApproval}
      ipPermitApproval={ipPermitApproval}
      testApproval={testApproval}
      migrationApproval={migrationApproval}
      requestManager={requestManager}
    />
  );
}
